var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackBackgroundBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3397_1737)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#5062F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6345 11.3483C22.1325 10.8702 22.9238 10.8863 23.4019 11.3843C23.9463 11.9514 23.7501 12.75 23.3651 13.1524C21.6184 14.8385 19.8733 16.5851 18.377 18.5L33.7501 18.5C34.4405 18.5 35.0001 19.0596 35.0001 19.75C35.0001 20.4404 34.4405 21 33.7501 21L18.377 21C19.8747 22.9168 21.6188 24.6619 23.3658 26.3483C23.8638 26.8264 23.8799 27.6177 23.4019 28.1157C22.9238 28.6137 22.132 28.6293 21.634 28.1513C19.7282 26.3119 17.8318 24.4235 16.2303 22.3095C15.6841 21.5886 15.0001 20.6993 15.0001 19.75C15.0001 18.8007 15.6841 17.9114 16.2303 17.1905C17.8274 15.0823 19.7355 13.181 21.6345 11.3483Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3397_1737",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3397_1737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3397_1737",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBackgroundBlue);
export default __webpack_public_path__ + "static/media/arrowBackBackgroundBlue.8fcc90af43b98fbffcb44f9873484edd.svg";
export { ForwardRef as ReactComponent };